import {ReactComponent as WEIGHTAGE_ICON} from "../images/weightage_purple.svg"
import {ReactComponent as CHECK_ICON} from "../images/check_marker_purple.svg"
import {
    CUSTOM_TEXT,
    POINT_TEXT,
    POINTS_TEXT,
    QUESTION_MAX_POINTS,
    UNGRADED_Cap,
    YUJA_DROPDOWN_SIZE
} from "../utils/constants";
import {YuJaDropdown} from "./standardization/YuJaDropdown";
import {useEffect, useRef, useState} from "react";
import classes from "./Dropdown.module.css";
import {YuJaTooltip} from "./standardization/YuJaTooltip";
import {QUESTION_POINTS_RANGE_ERROR} from "../utils/toast-message-constants";
import {notifyError} from "../utils/helpers";

export default function DropdownWeightage({setWeightage, weightage}) {
    const [isSelectedCustom, setIsSelectedCustom] = useState(false);
    const inputRef = useRef();
    const [inputVal, setInputVal] = useState("");

    const options = [
        {label: UNGRADED_Cap, value: "0"},
        {label: "1 " + POINT_TEXT, value: "1"},
        {label: "3 " + POINTS_TEXT, value: "3"},
        {label: "5 " + POINTS_TEXT, value: "5"},
        {label: CUSTOM_TEXT, value: "-1"},
    ];

    const translateDropdownValue = (weightage) => {
        if (!weightage || isNaN(weightage)) {
            return "0";
        }

        if (weightage === 1 || weightage === 3 || weightage === 5) {
            return weightage.toString();
        }

        return "-1";
    }

    const onChange = (option) => {
        if (option.value === "-1") {
            setIsSelectedCustom(true);
            setInputVal(translateDropdownValue(weightage) !== "-1" ? "" : weightage);
        } else {
            setWeightage(parseInt(option.value));
        }
    }

    useEffect(() => {
        if (isSelectedCustom) {
            inputRef.current.focus();
        }
    }, [isSelectedCustom]);

    const onChangeCustomInput = (e) => {
        let input = e.target.value;

        let result = '';
        for (let i = 0; i < input.length; i++) {
            const char = input[i];
            if (/\d/.test(char)) {
                result += char;
            }
        }

        setInputVal(result);
    }


    const onBlur = (e) => {
        if (e.target.value !== undefined && e.target.value !== "") {
            let val = parseInt(e.target.value);
            if (val > QUESTION_MAX_POINTS) {
                setWeightage(QUESTION_MAX_POINTS);
                notifyError(QUESTION_POINTS_RANGE_ERROR);
            } else if (val < 0) {
                setWeightage(0);
                notifyError(QUESTION_POINTS_RANGE_ERROR);
            } else {
                setWeightage(val);
            }

        } else {
            setWeightage(0);
        }
        setIsSelectedCustom(false);
    }

    const customPresenter = () => {
        let val = translateDropdownValue(weightage);
        if (val === "-1") {
            return weightage + " Points";
        } else {
            return options.find(opt => opt.value === val).label;
        }
    }



    return (
        <div style={{position: 'relative', width: 170, height: 35}}>
            <div
                className={classes.inputContainer}
                style={{visibility: isSelectedCustom ? "visible" : "hidden",}}
            >
                <span className={classes.icon}><WEIGHTAGE_ICON/></span>
                <YuJaTooltip placement={"bottom"} text={"Enter points"}>
                    <input
                        ref={inputRef}
                        value={inputVal}
                        onChange={onChangeCustomInput}
                        onBlur={onBlur}
                        placeholder={"  " + POINTS_TEXT}
                    />
                </YuJaTooltip>
                {isSelectedCustom &&
                    <CHECK_ICON style={{cursor: "pointer"}} title={"confirm"}/>
                }
            </div>


            <YuJaDropdown
                ariaLabel={"Points"}
                size={YUJA_DROPDOWN_SIZE.SMALL}
                style={{width: 170, padding: "0 6px"}}
                data={options}
                value={translateDropdownValue(weightage)}
                onChange={onChange}
                customPresenter={customPresenter}
                presenterIcon={<span className={classes.icon}><WEIGHTAGE_ICON/></span>}
            />
        </div>
    );
}